"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BusinessRegion_1 = require("./BusinessRegion");
class Organization {
    constructor({ id, name, pointBalance, features, businessRegion, }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            pointBalance: this.pointBalance,
            features: this.features,
            businessRegion: this.businessRegion,
        });
        this.id = id;
        this.name = name;
        this.pointBalance = pointBalance;
        this.features = features;
        this.businessRegion = businessRegion;
    }
}
Organization.fromJSON = (json) => {
    const { id, name, pointBalance, features, businessRegion } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (name !== undefined && typeof name !== 'string')
        throw new Error('.name must be a string');
    if (features !== undefined &&
        features.canOpenOfferWhenDisagreed !== undefined &&
        typeof features.canOpenOfferWhenDisagreed !== 'boolean')
        throw new Error('.features.canOpenOfferWhenDisagreed must be a boolean');
    const _businessRegion = businessRegion ? BusinessRegion_1.default.fromJSON(businessRegion) : undefined;
    return new Organization({ id, name, pointBalance, features, businessRegion: _businessRegion });
};
exports.default = Organization;
